module.exports = {
          srcSet: "/_next/static/images/google-calendar-48-83f3dad5d3662b384574a3f325c76410.webp"+" 48w",
          images:[ {path: "/_next/static/images/google-calendar-48-83f3dad5d3662b384574a3f325c76410.webp",width: 48,height: 48}],
          src: "/_next/static/images/google-calendar-48-83f3dad5d3662b384574a3f325c76410.webp",
          toString:function(){return "/_next/static/images/google-calendar-48-83f3dad5d3662b384574a3f325c76410.webp"},
          
          width: 48,
          height: 48
        }